import forge from 'node-forge';
export function getKeyBytes(key) {
    const padded = (key + '0000000000000000').slice(0, 16);
    return forge.util.createBuffer(padded, 'utf8').getBytes();
  }

  export function encryptAES (nationalId, timeStamp) {
    const key = "2Wz*7^L5$mA*As)$";
    const text = nationalId+timeStamp;
    let result = "";
  
    for (let i = 0; i < text.length; i++) {
      result += String.fromCharCode(
        text.charCodeAt(i) ^ key.charCodeAt(i % key.length)
      );
    }
  
    return btoa(result);
  };
  


 